import { UserService } from './../../../../shared/services/user/user.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { PaginacaoResponse } from '../../../../models/paginacaoResponse.interface';
import {
  alunoRequest,
  alunoResponse,
  ListarAlunosParams,
} from './../../../../models/alunos.interface';
import {
  listarPaginacao,
  Post,
  SingleResponse,
} from '../../../../models/rest.interface';
import { fichaMedica } from '../../../../models/ficha-medica.interface';
import {
  meritoRequest,
  meritosResponse,
} from '../../../../models/merito.interface';
import {
  advertenciaRequest,
  advertenciaResponse,
} from '../../../../models/advertencias.interface';
import * as qs from 'qs';
import {
  medicacao,
  medicacao_horario,
  medicacao_unidade,
} from '../app-mobile/ficha-medica/ficha-medica.component';
import { inviteResponsavel } from '../../../../models/convite.interface';
import { filtroDeBusca } from '../../../../models/filtro-busca.interface';
const URL_BASE_ALUNOS = `${environment.BACKEND_API}/alunos`;
const URL_BASE = `${environment.BACKEND_API}`;
const URL_FICHA_MEDICA = `${environment.BACKEND_API}/ficha-medicas`;
const URL = environment.BACKEND_API + '/invites';
export interface aluno {
  component: string;
  documentIdAluno: string;
  idAluno: any;
}
@Injectable({
  providedIn: 'root',
})
export class AlunosService {
  alunoSelecionado = new BehaviorSubject<alunoSelecionado | null>(null);
  aluno!: alunoResponse;
  private alunoSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  fotoAluno = new BehaviorSubject<fotoAluno>({ foto: null, lado: '' });
  escolaId!: number;
  documentIdEscola: string = '';

  constructor(
    private http: HttpClient,
    private readonly userService: UserService,
  ) {
    this.userService.escola.subscribe((escola: any) => {
      if (escola !== undefined) {
        this.escolaId = escola.id;
        this.documentIdEscola = escola.value;
      }
    });
  }

  get getAluno(): any {
    return this.alunoSubject.getValue();
  }

  setAluno(aluno: any) {
    this.alunoSubject.next(aluno);
  }

  uploadFile(file: File | undefined, alunoId: string, field: string) {
    const formData = new FormData();
    formData.append('file', file as File);
    formData.append('alunoId', alunoId);
    formData.append('field', field);

    return this.http.post(URL_BASE + '/custom-upload', formData);
  }

  editUserWithAlunos(
    documentIdAluno: string,
    documentIdUser: string[],
  ): Observable<any> {
    const body = {
      data: {
        users: {
          connect: documentIdUser, // array de documentId (string)
        },
      },
    };
    return this.http.put<any>(`${URL_BASE}/alunos/${documentIdAluno}`, body);
  }

  buscarFotoPorId(idFoto: number): Observable<Blob> {
    return this.http.get(URL_BASE + '/custom-files/' + idFoto, {
      responseType: 'blob',
    });
  }

  buscarTurmaPorAluno(idAluno: number, anoLetivo: any): Observable<any> {
    return this.http.get<any>(
      `${URL_BASE}/turmas/?filters[$and][0][alunos][$eq]=${idAluno}&filters[$and][1][ativo][$eq]=true&filters[$and][2][anoLetivo][$eq]=${anoLetivo}&populate=curso`,
    );
  }

  buscarTurmaDoAluno(idAluno: number, anoLetivo: number): Observable<any> {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              alunos: {
                $eq: idAluno,
              },
              ativo: {
                $eq: true,
              },
              anoLetivo: {
                $eq: anoLetivo,
              },
            },
          ],
        },
        populate: {
          curso: {
            populate: {
              materias: {
                populate: {
                  notas: {
                    filters: {
                      aluno: {
                        $eq: idAluno,
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        encodeValuesOnly: true,
      },
    );
    return this.http.get<any>(`${URL_BASE}/turmas/?${query}`);
  }

  buscarTurmaPorAlunoAPP(idAluno: number, anoLetivo: number): Observable<any> {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              alunos: {
                $eq: idAluno,
              },
            },
            {
              anoLetivo: {
                $eq: anoLetivo,
              },
            },
            {
              ativo: {
                $eq: true,
              },
            },
            {
              escola: {
                $eq: this.escolaId,
              },
            },
          ],
        },
        populate: {
          curso: true,
          frequencias: {
            filters: {
              alunos: {
                $eq: idAluno,
              },
            },
            populate: ['alunos'],
          },
        },
      },
      {
        encodeValuesOnly: true,
      },
    );

    return this.http.get<any>(`${URL_BASE}/turmas?${query}`);
  }

  buscarTurmaPorIdAlunoApp(
    idAluno: number,
    anoLetivo: number,
    documentId: string,
  ): Observable<any> {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              documentId: {
                $eq: documentId,
              },
            },
            {
              alunos: {
                $eq: idAluno,
              },
            },
            {
              anoLetivo: {
                $eq: anoLetivo,
              },
            },
            {
              ativo: {
                $eq: true,
              },
            },
          ],
        },
        populate: {
          curso: true,
          frequencias: {
            filters: {
              alunos: {
                $eq: idAluno,
              },
            },
            populate: ['alunos'],
          },
        },
      },
      {
        encodeValuesOnly: true,
      },
    );

    return this.http.get<any>(`${URL_BASE}/turmas?${query}`);
  }

  buscarTurmaPorIdAlunoAPP(idAluno: number, idTurma: number): Observable<any> {
    const query = qs.stringify(
      {
        filters: {
          $and: [{ id: { $eq: idTurma } }, { ativo: { $eq: true } }],
        },
        populate: {
          curso: true,
          frequencias: {
            filters: {
              alunos: {
                $eq: idAluno,
              },
            },
            populate: ['alunos'],
          },
        },
      },
      {
        encodeValuesOnly: true,
      },
    );

    return this.http.get<any>(`${URL_BASE}/turmas?${query}`);
  }

  buscarAlunosDoResponsavel(idUser: number): Observable<any> {
    return this.http.get<any>(
      `${URL_BASE_ALUNOS}/?filters[users][$eq]=${idUser}`,
    );
  }

  buscarChamadasPorMateriaAlunoTurma(
    idTurma: number,
    idMateria: number,
    idAluno: number,
    params: listarPaginacao = {},
  ): Observable<any> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<any>(
      `${URL_BASE}/frequencias/?filters[$and][0][turmas][$eq]=${idTurma}&filters[$and][1][alunos][$eq]=${idAluno}&filters[$and][2][materias][$eq]=${idMateria}&populate[0]=grade_curriculars&populate[1]=users&populate[2]=alunos&sort=createdAt:desc`,
      { params: httpParams },
    );
  }

  listarAlunosSemTurmas(
    params: ListarAlunosParams = {},
  ): Observable<PaginacaoResponse<alunoResponse>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<PaginacaoResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?filters[$and][0][turmas][nome][$null]=true&filters[$and][1][escolas][$eq]=${this.escolaId}`,
      { params: httpParams },
    );
  }

  buscarFichaMedicaPorId(
    idFicha: string,
  ): Observable<SingleResponse<fichaMedica>> {
    return this.http.get<SingleResponse<fichaMedica>>(
      `${URL_FICHA_MEDICA}/${idFicha}`,
    );
  }

  buscarObservacoes(idAluno: number): Observable<any> {
    return this.http.get<any>(
      `${URL_BASE}/observacaos/?filters[$and][0][aluno][$eq]=${idAluno}&populate=*`,
    );
  }

  buscarObservacoesPorData(data: any): Observable<any> {
    return this.http.get<any>(
      `${URL_BASE}/observacaos/?&filters[$and][0][createdAt][$containsi]=${data}&populate=*`,
    );
  }

  convidarUsuario(convite: Post<inviteResponsavel>): Observable<any> {
    return this.http.post<any>(`${URL}`, convite);
  }

  listarObservacoesPorData(
    data: string,
    documentId: string,
    params: ListarAlunosParams = {},
  ): Observable<any> {
    const query = qs.stringify({
      // filters: {
      //   documentId: {
      //     $eq: documentId,
      //   },
      // },
      populate: {
        observacaos: {
          filters: {
            createdAt: {
              $containsi: data,
            },
          },
          populate: {
            user: {
              populate: {
                permissaos: true,
              },
            },
          },
        },
      },
    });

    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<any>(`${URL_BASE}/turmas/${documentId}?${query}`, {
      params: httpParams,
    });
  }

  salvarObservacao(observacaos: Post<any>): Observable<any> {
    return this.http.post<any>(`${URL_BASE}/observacaos`, observacaos);
  }

  editarObservacao(
    observacaos: Post<any>,
    documentId: string,
  ): Observable<any> {
    return this.http.put<any>(
      `${URL_BASE}/observacaos/${documentId}`,
      observacaos,
    );
  }

  buscarMeritosPorAluno(): Observable<any> {
    return this.http.get<any>(
      `${URL_BASE}/meritos?filters[aluno][$eq]=${this.aluno.id}`,
    );
  }

  buscarObservacaoPorId(
    idObservacao: string,
    populate?: boolean,
  ): Observable<any> {
    if (populate) {
      return this.http.get<any>(`${URL_BASE}/observacaos/${idObservacao}`);
    }
    return this.http.get<any>(
      `${URL_BASE}/observacaos/${idObservacao}?populate=user`,
    );
  }

  // buscarObservacaoPorId(idObservacao: string): Observable<any> {
  //   return this.http.get<any>(`${URL_BASE}/observacaos/?filters[documentId][$eq]=${idObservacao}&populate=user`);
  // }

  buscarMeritosPorId(idMerito: string): Observable<any> {
    return this.http.get<any>(`${URL_BASE}/meritos/${idMerito}`);
  }
  buscarAdvertenciaPorId(idAdvertencia: string): Observable<any> {
    return this.http.get<any>(`${URL_BASE}/advertencias/${idAdvertencia}`);
  }

  salvarMerito(
    merito: Post<meritoRequest>,
  ): Observable<SingleResponse<meritosResponse>> {
    return this.http.post<SingleResponse<meritosResponse>>(
      `${URL_BASE}/meritos`,
      merito,
    );
  }

  salvarAdvertencia(
    advertencia: Post<advertenciaRequest>,
  ): Observable<SingleResponse<advertenciaResponse>> {
    return this.http.post<SingleResponse<advertenciaResponse>>(
      `${URL_BASE}/advertencias`,
      advertencia,
    );
  }

  buscarAdvertenciasPorAluno(): Observable<any> {
    return this.http.get<any>(
      `${URL_BASE}/advertencias?filters[aluno][$eq]=${this.aluno.id}`,
    );
  }

  listarAlunos(
    params: ListarAlunosParams = {},
  ): Observable<PaginacaoResponse<alunoResponse>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<PaginacaoResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}`,
      { params: httpParams },
    );
  }

  listarPorEscolas(
    params: ListarAlunosParams = {},
  ): Observable<PaginacaoResponse<alunoResponse>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<PaginacaoResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?filters[escolas][$eq]=${this.escolaId}`,
      { params: httpParams },
      // &populate=*
    );
  }

  listarAlunosVincular(
    params: filtroDeBusca,
  ): Observable<PaginacaoResponse<alunoResponse>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', params.page.toString())
      .set('pagination[pageSize]', params.limit.toString());
    return this.http.get<PaginacaoResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?populate=users`,
      { params: httpParams },
      // &populate=*
    );
  }

  listagemAlunos(
    params: ListarAlunosParams = {},
  ): Observable<PaginacaoResponse<alunoResponse>> {
    let httpParams = new HttpParams()
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<PaginacaoResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?filters[escolas][$eq]=${this.escolaId}&populate=ficha_medica`,
      { params: httpParams },
    );
  }

  listagemAlunosPorProfessor(
    userId: number,
    params: ListarAlunosParams = {},
  ): Observable<PaginacaoResponse<alunoResponse>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    const query = qs.stringify({
      filters: {
        escolas: { $eq: this.escolaId },
        turmas: {
          users: { $eq: userId },
        },
      },
      populate: {
        ficha_medica: true,
      },
    });

    return this.http.get<PaginacaoResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?${query}`,
      { params: httpParams },
    );
  }

  buscarAlunoPor(find: string): Observable<SingleResponse<alunoResponse>> {
    return this.http.get<SingleResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?filters[escolas][$eq]=${this.escolaId}&filters[$and][1][nome][$containsi]=${find}`,
    );
  }

  buscarAlunoPorNome(find: string): Observable<SingleResponse<alunoResponse>> {
    return this.http.get<SingleResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?filters[$and][0][nome][$containsi]=${find}&populate=users`,
    );
  }

  buscarAlunoPorNascimento(
    find: string,
  ): Observable<SingleResponse<alunoResponse>> {
    return this.http.get<SingleResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?filters[escolas][$eq]=${this.escolaId}&filters[$and][1][dataNascimento][$eq]=${find}`,
    );
  }

  buscarAlunoPorId(idAluno: string): Observable<SingleResponse<alunoResponse>> {
    return this.http.get<SingleResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/${idAluno}?populate[0]=users&populate[1]=ficha_medica&populate[2]=observacaos&populate[3]=foto_frontal`,
    );
  }

  buscarAlunoPorIdPopulateFotos(
    idAluno: string,
  ): Observable<SingleResponse<any>> {
    return this.http.get<SingleResponse<any>>(
      `${URL_BASE_ALUNOS}/${idAluno}?populate[0]=foto_frontal&populate[1]=foto_direito&populate[2]=foto_esquerdo`,
    );
  }

  buscarMeritosPorAno(data: any, idAluno: any): Observable<any> {
    return this.http.get<any>(
      `${URL_BASE}/observacaos/?filters[$and][0][aluno][$eq]=${idAluno}&filters[$and][1][createdAt][$containsi]=${data}&filters[$and][2][tipoObservacao][$eq]=0&populate=*`,
    );
  }

  buscarAdvertenciaPorAno(data: any, idAluno: any): Observable<any> {
    return this.http.get<any>(
      `${URL_BASE}/observacaos/?filters[$and][0][aluno][$eq]=${idAluno}&filters[$and][1][createdAt][$containsi]=${data}&filters[$and][2][tipoObservacao][$eq]=1&populate=*`,
    );
  }
  buscarInformativosPorAno(data: any, idAluno: any): Observable<any> {
    return this.http.get<any>(
      `${URL_BASE}/observacaos/?filters[$and][0][aluno][$eq]=${idAluno}&filters[$and][1][createdAt][$containsi]=${data}&filters[$and][2][tipoObservacao][$eq]=2&populate=*`,
    );
  }

  buscarMeritoPorAluno(idAluno: any, find: any): Observable<any> {
    return this.http.get<any>(
      `${URL_BASE}/meritos/?filters[$and][0][aluno][$eq]=${idAluno}&filters[$and][1][tipo][$containsi]=${find}`,
    );
  }

  buscarAdvertenciaPorAluno(idAluno: any, find: any): Observable<any> {
    return this.http.get<any>(
      `${URL_BASE}/advertencias/?filters[$and][0][aluno][$eq]=${idAluno}&filters[$and][1][tipo][$containsi]=${find}`,
    );
  }

  buscarAluno(idAluno: string): Observable<SingleResponse<any>> {
    return this.http.get<SingleResponse<any>>(
      `${URL_BASE_ALUNOS}/${idAluno}?populate=*`,
    );
  }

  editarAluno(
    idAluno: any,
    alunoRequest: SingleResponse<alunoRequest>,
  ): Observable<SingleResponse<alunoResponse>> {
    return this.http.put<SingleResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/${idAluno}`,
      alunoRequest,
    );
  }

  editarAlunoConnectUser(
    documentIdAluno: string,
    user: string[],
  ): Observable<SingleResponse<alunoResponse>> {
    const body = {
      data: {
        alunos: {
          connect: user, // array de documentId (string)
        },
      },
    };
    return this.http.put<SingleResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/${documentIdAluno}`,
      user,
    );
  }

  desconectarAlunoEscola(idAluno: string): Observable<any> {
    const body = {
      data: {
        escolas: {
          disconnect: [this.documentIdEscola],
        },
      },
    };
    return this.http.put(`${URL_BASE_ALUNOS}/${idAluno}`, body);
  }

  desconectarAlunoDoResponsavel(
    idAluno: string,
    idResponsavel: string,
  ): Observable<any> {
    const body = {
      data: {
        users: {
          disconnect: [idResponsavel],
        },
      },
    };
    return this.http.put(`${URL_BASE_ALUNOS}/${idAluno}`, body);
  }

  cadastrarAluno(alunoRequest: Post<alunoRequest>): Observable<any> {
    return this.http.post<any>(`${URL_BASE_ALUNOS}`, alunoRequest);
  }

  cadastrarFichaMedica(
    fichaMedica: Post<alunoRequest>,
  ): Observable<SingleResponse<fichaMedica>> {
    return this.http.post<SingleResponse<fichaMedica>>(
      `${URL_FICHA_MEDICA}`,
      fichaMedica,
    );
  }

  editarFichaMedica(
    fichaMedica: Post<fichaMedica>,
    idFichaMedica: string,
  ): Observable<any> {
    return this.http.put(`${URL_FICHA_MEDICA}/${idFichaMedica}`, fichaMedica);
  }

  salvarMedicacaoUnidade(medicacao: Post<medicacao_unidade>): Observable<any> {
    return this.http.post<SingleResponse<medicacao_unidade>>(
      `${URL_BASE}/medicacao-unidades`,
      medicacao,
    );
  }

  salvarMedicacaoHorario(medicacao: Post<medicacao_horario>): Observable<any> {
    return this.http.post<SingleResponse<medicacao_horario>>(
      `${URL_BASE}/medicacao-horarios`,
      medicacao,
    );
  }

  salvarMedicacao(
    medicacao: Post<medicacao>,
  ): Observable<SingleResponse<medicacao>> {
    return this.http.post<SingleResponse<medicacao>>(
      `${URL_BASE}/medicacaos`,
      medicacao,
    );
  }

  buscarMedicacoes(idAluno: number): Observable<any> {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              aluno: {
                $eq: idAluno,
              },
            },
          ],
        },
        populate: {
          medicacao_horarios: {
            populate: {
              medicacao_unidade: true,
            },
          },
        },
      },
      {
        encodeValuesOnly: true,
      },
    );

    return this.http.get<SingleResponse<alunoResponse>>(
      `${URL_BASE}/medicacaos/?${query}`,
    );
  }

  deletarMedicamento(idMedicamento: number): Observable<any> {
    return this.http.delete<any>(`${URL_BASE}/medicacaos/${idMedicamento}`);
  }

  editarMedicamento(idMedicamento: number, medicamento: any): Observable<any> {
    return this.http.put<any>(
      `${URL_BASE}/medicacaos/${idMedicamento}`,
      medicamento,
    );
  }

  buscarAlunosPorTurma(
    idTurma: number,
  ): Observable<SingleResponse<alunoResponse>> {
    return this.http.get<SingleResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?filters[turmas][$eq]=${idTurma}&populate=*`,
    );
  }

  buscarAlunosPorTurmaNotas(
    idTurma: number,
    idMateria: number,
    params: listarPaginacao = {},
  ): Observable<SingleResponse<alunoResponse>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              turmas: {
                $eq: idTurma,
              },
            },
          ],
        },
        populate: {
          notas: {
            filters: {
              materia: {
                $eq: idMateria,
              },
              turma: {
                $eq: idTurma,
              },
            },
            // populate: ['aluno'],
          },
        },
      },
      {
        encodeValuesOnly: true,
      },
    );

    return this.http.get<SingleResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?${query}`,
      { params: httpParams },
    );
  }

  buscarAvaliacaoAluno(
    idTurma: number,
    idMateria: number,
    idAluno: string,
  ): Observable<SingleResponse<alunoResponse>> {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              documentId: {
                $eq: idAluno,
              },
              turmas: {
                $eq: idTurma,
              },
            },
          ],
        },
        populate: {
          notas: {
            filters: {
              materia: {
                $eq: idMateria,
              },
              turma: {
                $eq: idTurma,
              },
            },
            // populate: ['aluno'],
          },
        },
      },
      {
        encodeValuesOnly: true,
      },
    );

    return this.http.get<SingleResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?${query}`,
    );
  }

  buscarAlunosPorTurmaNotasFindAluno(
    idTurma: number,
    idMateria: number,
    aluno: string,
    params: listarPaginacao = {},
  ): Observable<SingleResponse<alunoResponse>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              turmas: {
                $eq: idTurma,
              },
            },
            {
              nome: {
                $containsi: aluno,
              },
            },
          ],
        },
        populate: {
          notas: {
            filters: {
              materia: {
                $eq: idMateria,
              },
            },
            // populate: ['aluno'],
          },
        },
      },
      {
        encodeValuesOnly: true,
      },
    );

    return this.http.get<SingleResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?${query}`,
      { params: httpParams },
    );
  }

  buscarAlunosPorTurmaNotasGeral(
    idTurma: number,
    idMateria: number,
    idAluno: string,
  ): Observable<SingleResponse<alunoResponse>> {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              turmas: {
                $eq: idTurma,
              },
            },
            {
              documentId: {
                $eq: idAluno,
              },
            },
          ],
        },
        populate: {
          notas: {
            filters: {
              materia: {
                $eq: idMateria,
              },
              turma: {
                $eq: idTurma,
              },
            },
            // populate: ['aluno'],
          },
        },
      },
      {
        encodeValuesOnly: true,
      },
    );

    return this.http.get<SingleResponse<alunoResponse>>(
      `${URL_BASE_ALUNOS}/?${query}`,
    );
  }
}

export interface alunoSelecionado {
  nomeAluno: string;
  documentId: string;
  id: number;
}

export interface fotoAluno {
  lado: string;
  foto: any;
}
